import { Box, styled } from "@mui/material";

/** Two-column form grid used by every ACC20C02 section. */
export const FieldGrid = styled(Box, { shouldForwardProp: (prop) => prop !== "columns" })<{ columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns = 2 }) => columns}, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
`;

/** Cell that stretches across several grid columns (full-width fields, nested rows). */
export const FieldGridItem = styled(Box, { shouldForwardProp: (prop) => prop !== "span" })<{ span?: number }>`
  grid-column: span ${({ span = 1 }) => span};
  min-width: 0;
`;
